import { useNavigate } from "react-router-dom";
import { PAGE_NAME_SEARCH_HISTORY } from "../../../../constants/common_constants";
import { useTranslation } from "react-i18next";
import OpenIssue from "../../../../icons/Open Issue.svg";

interface UnansweredInfoProps {
  unansweredNum: number;
}
export const UnansweredInfo: React.FC<UnansweredInfoProps> = ({
  unansweredNum,
}) => {
  // ページ遷移用
  const navigate = useNavigate();
  //言語切替用
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col gap-2">
        <button
          className="flex relative"
          onClick={() =>
            navigate(`/${PAGE_NAME_SEARCH_HISTORY}`, {
              state: { isFromUnanswered: true },
            })
          }
        >
          <img
            src={OpenIssue}
            alt="OpenIssue"
            className="size-[14vh] bg-white border-2 border-gray-300"
          />
          {unansweredNum > 0 ? (
            <p
              className={`${unansweredNum >= 1000 ? "w-14" : "w-10"} 
              absolute -top-3 -right-4 bg-main-red flex border-4 border-white justify-center items-center text-white text-sm h-10 rounded-full 
              `}
            >
              {unansweredNum >= 1000 ? "999+" : unansweredNum}
            </p>
          ) : null}
        </button>
        {t("トップ画面.未解決項目")}
      </div>
    </>
  );
};
